import { render, staticRenderFns } from "./ModalOrganSystem.vue?vue&type=template&id=c9e1450e&scoped=true&"
import script from "./ModalOrganSystem.vue?vue&type=script&lang=js&"
export * from "./ModalOrganSystem.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrganSystem.vue?vue&type=style&index=0&id=c9e1450e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e1450e",
  null
  
)

export default component.exports